<div [animate.enter]="'notification-enter'" class="px-4 py-2 bg-primary-50 rounded-xl flex justify-between items-center">
  <div>

    <label [translate]="'notification.' + this.type()" [translateParams]="{author: this.notification().authorFullName}"
           class="font-medium"></label>
    <div>
      {{ this.notification().description }}
    </div>
  </div>
  <div>
    <elcia-button [icon]="'check'" [severity]="'secondary'" [size]="'small'" (onClick)="deleteNotification()"/>
  </div>
</div>
